/**
 * Pathname → PageGuide pageId registry.
 * Longest matching prefix wins. Unknown routes → null (icon not offered).
 */

/** @type {Array<{ prefix: string, pageId: string }>} */
export const PAGE_GUIDE_ROUTE_ENTRIES = [
  // More specific paths first (also sorted by length at resolve time)
  { prefix: "/carestart-plus/registration", pageId: "carestart-plus-registration" },
  { prefix: "/carestart-plus/triage", pageId: "carestart-plus-triage" },
  { prefix: "/carestart-plus/hpi", pageId: "carestart-plus-hpi" },
  { prefix: "/carestart-plus/discharge", pageId: "carestart-plus-discharge" },
  { prefix: "/carestart-plus", pageId: "carestart-plus" },
  { prefix: "/carestart3", pageId: "carestart3" },
  { prefix: "/masterchart/demographics", pageId: "masterchart-demographics" },
  { prefix: "/masterchart/conditions", pageId: "masterchart-conditions" },
  { prefix: "/masterchart/surgical-history", pageId: "masterchart-surgical-history" },
  { prefix: "/masterchart/allergies", pageId: "masterchart-allergies" },
  { prefix: "/masterchart/other-history", pageId: "masterchart-other-history" },
  { prefix: "/masterchart/share", pageId: "masterchart-share" },
  { prefix: "/masterchart", pageId: "masterchart" },
  { prefix: "/healthcontours/signup", pageId: "healthcontours-signup" },
  { prefix: "/healthcontours/advertise", pageId: "healthcontours-advertise" },
  { prefix: "/healthcontours/audience", pageId: "healthcontours-audience" },
  { prefix: "/healthcontours", pageId: "healthcontours" },
  { prefix: "/visit-start", pageId: "visit-start" },
  { prefix: "/careverify", pageId: "careverify" },
  { prefix: "/caremap2", pageId: "caremap" },
  { prefix: "/caremap", pageId: "caremap" },
  { prefix: "/chartmind-plus", pageId: "chartmind-plus" },
  { prefix: "/chartmind-i2", pageId: "chartmind-i2" },
  { prefix: "/chartmind-i", pageId: "chartmind-i" },
  { prefix: "/dashboard/chartmind", pageId: "dashboard-chartmind" },
  { prefix: "/chartmind", pageId: "dashboard-chartmind" },
  { prefix: "/dp-display", pageId: "dp-display" },
  // FusionMSI host (fusionmsi.com) serves DecisionPoint at /display; /dp-display redirects there.
  { prefix: "/display", pageId: "dp-display" },
  { prefix: "/dashboard/savoircare", pageId: "dashboard-savoircare" },
  { prefix: "/dashboard/linked-providers", pageId: "linked-providers" },
  { prefix: "/dashboard/med-reconciliation", pageId: "med-reconciliation" },
  { prefix: "/dashboard/reports", pageId: "dashboard-reports" },
  { prefix: "/dashboard/readiness", pageId: "dashboard-readiness" },
  { prefix: "/dashboard/prompts", pageId: "dashboard-prompts" },
  { prefix: "/dashboard/page-guide", pageId: "dashboard-page-guide" },
  { prefix: "/dashboard/care-gaps", pageId: "dashboard-care-gaps" },
  { prefix: "/dashboard/results", pageId: "dashboard-results" },
  { prefix: "/dashboard/peerview", pageId: "dashboard-peerview" },
  { prefix: "/dashboard/drug-reference", pageId: "dashboard-drug-reference" },
  { prefix: "/dashboard/specialty-kb", pageId: "dashboard-specialty-kb" },
  { prefix: "/specialty-kb/editors", pageId: "specialty-kb-editors" },
  { prefix: "/specialty-kb/ddx", pageId: "specialty-kb-ddx" },
  { prefix: "/dashboard", pageId: "dashboard" },
  { prefix: "/news", pageId: "news" },
  { prefix: "/fitness", pageId: "fitness" },
  { prefix: "/email", pageId: "email" },
  { prefix: "/asi/templates", pageId: "asi-templates" },
  { prefix: "/clinical-hud-3", pageId: "clinical-hud-3" },
  { prefix: "/clinical-hud-2", pageId: "clinical-hud-2" },
  { prefix: "/chartmind-7", pageId: "chartmind-7" },
  { prefix: "/clinical-hud", pageId: "clinical-hud" },
  { prefix: "/voxpont12", pageId: "voxpont4" },
  { prefix: "/voxpont4", pageId: "voxpont4" },
  // SecureLink Discharge Import patient landing (not CareStart Plus discharge).
  { prefix: "/discharge", pageId: "ehr-discharge" },
];

/**
 * @param {string} pathname
 * @returns {string|null}
 */
export function resolvePageGuidePageId(pathname) {
  if (!pathname || typeof pathname !== "string") return null;
  const path = pathname.split("?")[0].split("#")[0];
  if (!path || path === "/") return null;

  let best = null;
  let bestLen = -1;
  for (const entry of PAGE_GUIDE_ROUTE_ENTRIES) {
    const { prefix, pageId } = entry;
    if (!prefix || !pageId) continue;
    const matches =
      path === prefix ||
      path.startsWith(`${prefix}/`) ||
      (prefix.endsWith("/") && path.startsWith(prefix));
    if (matches && prefix.length > bestLen) {
      best = pageId;
      bestLen = prefix.length;
    }
  }
  return best;
}
